// Version of the Beco movie the user chose to watch. Mirrors the API's
// TipoAcessibilidade enum (values are the API's JSON representation).
enum TipoAcessibilidade {
    ORIGINAL = 'original',
    AUDIODESCRICAO = 'audiodescricao',
    LIBRAS = 'libras',
}

export default TipoAcessibilidade;
